import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import moment from 'moment-timezone';
import 'moment-duration-format';

import { NoRides } from '../NoRides';
import { Display } from '../Display';
import JourneyMap from '../JourneyMap';
import {
  changeCurrentJourney,
  previewJourney,
} from '../Sidebar/RidesSidebar/actions';
import { getLocationText } from '../../utils/geo';

@connect(
  state => ({
    noRidesForMonth: !(
      !state.rides.areJourneysForMonthLoaded ||
      state.rides.areJourneysForMonthExist
    ),
    journey: state.dashboard.lastJourney,
    currentDeviceStats:
      state.devices.devicesStats
        .filter(value => value.deviceId === state.devices.currentDevice.id)
        .pop() || {},
    currentLanguage: state.langs.currentLanguage,
  }),
  dispatch => ({
    changeJourney(journey) {
      return dispatch(changeCurrentJourney({ journey }));
    },
    changePreviewJourney(journey) {
      return dispatch(previewJourney({ journey }));
    },
  }),
)
@translate(['dashboard'], { wait: true })
export default class DashboardMap extends Component {
  render() {    
    const { journey, currentDeviceStats, t, noRidesForMonth } = this.props;
    const daysText = t('dashboard:days');
    const hoursText = t('dashboard:hours');
    const minsText = t('dashboard:min');
    const disableClickZoom = true;
    
    const eventsCount = journey
      ? journey.scoring.accelerations.eventsCount +
        journey.scoring.brakings.eventsCount +
        journey.scoring.cornerings.eventsCount +
        journey.scoring.speedings.eventsCount
      : 0;
    const fuelCost = journey
      ? Math.round(journey.journey.stat.fuelCost / 100)
      : 0;
    const duration = journey
      ? moment
          .duration(journey.journey.stat.duration, 'seconds')
          .format(`d [${daysText}] h [${hoursText}] m [${minsText}]`)
      : t('dashboard:zero_mins');
    const distance = journey
      ? Math.round(journey.journey.stat.distance / 100) / 10
      : 0;
    const score = journey ? journey.scoring.score : 0;
    const journeyDate = journey
      ? moment(journey.journey.stat.startTime * 1000)
      : null;
    let date = '';

    if (journeyDate)
      console.log(journeyDate.format('dddd, HH:mm'))
    if (journeyDate && journeyDate.isSame(moment(), 'day')) {
      date = `${t('dashboard:today')}, ${journeyDate.format('HH:mm')}`;
    } else if (journeyDate) {
      date = journeyDate.format('dddd, HH:mm');
    }

    return (
      <div className="map-section">
        <div className="index-map">
          <JourneyMap
            scrollDisabled
            draggingDisabled
            doubleClickZoomDisabled={disableClickZoom}
            needSpeedingsRender
            journey={journey}
            currentDeviceStats={currentDeviceStats}
          />
        </div>
        <Display isShown={noRidesForMonth}>
          <div className="map-tooltip">
            <NoRides />
          </div>
        </Display>
        <Display isShown={!noRidesForMonth}>
          <div className="map-tooltip">
            <div className="map-tooltip__header">
              <span className="progress-circle" data-progress={score}>
                <span>
                  <em />
                </span>
                <span>
                  <em />
                </span>
              </span>
              <div className="map-tooltip__header__holder">
                <div className="date">
                  {date.charAt(0).toUpperCase() + date.slice(1)}
                </div>
                <div className="events">
                  {t('dashboard:events', { count: eventsCount })}
                </div>
              </div>
            </div>
            <div className="map-tooltip__events">
              <div className="map-tooltip__events__list">
                <div className="map-tooltip__events__item">
                  <div className="point">
                    <span>a</span>
                  </div>
                  <div className="holder">
                    {journey && getLocationText(journey.geoData.start)}
                  </div>
                </div>
                <div className="map-tooltip__events__item">
                  <div className="point">
                    <span>b</span>
                  </div>
                  <div className="holder">
                    {journey && getLocationText(journey.geoData.finish)}
                  </div>
                </div>
              </div>
            </div>
            <div className="map-tooltip__status">
              <div className="text">
                {distance} {t('dashboard:kmfor')} {duration}
              </div>
            </div>
            <div className="map-tooltip__footer">
              <Link
                onClick={() => {
                  this.props.changeJourney(journey);
                  this.props.changePreviewJourney(journey);
                }}
                to="/rides"
                className="more"
              >
                {t('dashboard:report')}
              </Link>
            </div>
          </div>
        </Display>
      </div>
    );
  }
}

DashboardMap.WrappedComponent.propTypes = {
  noRidesForMonth: PropTypes.bool.isRequired,
  journey: PropTypes.object,
  currentDeviceStats: PropTypes.object.isRequired,
  changeJourney: PropTypes.func.isRequired,
  changePreviewJourney: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

DashboardMap.WrappedComponent.defaultProps = {
  journey: {},
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardMap.js